import React from "react";
import ForbiddenIcon from '../assets/media/logos/forbidden.png'

export default function () {

  return (
    <>
      <div>
        <div id="forbidden" className="forbidden">
          <div className="order-total-values pt-20">
            <h1 className="text-center text-muted mt-20 mb-15 ls-1">Forbidden</h1>
            <div className="row">
              <div className="w-100 px-20 pb-8 px-20 mt-20 align-content-center">
                <img src={ForbiddenIcon}  className="w-25 mx-auto d-block" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}